import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchPrograms } from "../../redux/program/programActions";
import { getUsers } from "../../services/UserService";
import { viewTeacherWiseResultAnalysis } from "../../services/ResultService";
import Select from "../../components/Select/SearchableSelect";
import { FaUserTie, FaChevronDown, FaChevronUp } from "react-icons/fa";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import { enqueueSnackbar } from "notistack";
import * as XLSX from "xlsx";

const ResultAnalysisTeacherWise = () => {
  const [teacher_id, setTeacherID] = useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [teacherData, setTeacherData] = useState([]);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [exam_type, setExamType] = useState("");
  const dispatch = useDispatch();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "teacher_id") {
      setTeacherID(value);
    } else if (name === "exam_type") {
      setExamType(value);
    }
  };

  const fetchUserList = async (name, page) => {
    try {
      setLoader(true);
      const response = await getUsers({ name, page, pageSize: 150 });
      if (response.success) {
        setTeacherData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const fetchResultTeacherWise = async () => {
    try {
      setLoader(true);
      const response = await viewTeacherWiseResultAnalysis(
        teacher_id,
        exam_type
      );
      if (response.status === 200) {
        const resultData = response.data.data;
        setData(resultData);
        // Initialize all subjects as collapsed
        const initialExpandedState = {};
        resultData.forEach((_, idx) => {
          initialExpandedState[idx] = false;
        });
        setExpandedSubjects(initialExpandedState);
      }
    } catch (error) {
      console.error("Error fetching teacher-wise result analysis:", error);
    } finally {
      setLoader(false);
    }
  };

  const toggleSubjectExpand = (index) => {
    setExpandedSubjects((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    dispatch(fetchPrograms());
    fetchUserList("", 1, 150);
  }, [dispatch]);

  // const fetchResultTeacherWiseDownload = async () => {
  //   try {
  //     setLoader(true);
  //     enqueueSnackbar("Please wait. Preparing download...", {
  //       variant: "info",
  //     });
  // const response = await viewTeacherWiseResultAnalysis(
  //   teacher_id,
  //   exam_type
  // );

  // if (response.status === 200) {
  //   const result = response.data.data;

  //   if (!Array.isArray(result) || result.length === 0) {
  //     alert("No data to download");
  //     return;
  //   }
  //       const formattedData = result.map((item) => ({
  //         Teacher: item.teacher_name || "N/A",
  //         Class: item.program_name || "N/A",
  //         Subject: item.subject_name || "N/A",
  //         "Total Students": item.total_students || 0,
  //         AverageMarks: item.average_marks || 0,
  //         HighestMarks: item.highest_marks || 0,
  //         LowestMarks: item.lowest_marks || 0,
  //         MaxMarks: item.max_marks || 0
  //       }));
  //       // Convert JSON → Worksheet
  //       const ws = XLSX.utils.json_to_sheet(formattedData);

  //       // Create Workbook
  //       const wb = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(wb, ws, "Teacher Analysis");

  //       // Download Excel
  //       XLSX.writeFile(
  //         wb,
  //         `Teacher_Wise_Result_Analysis_${teacher_id || "All"}.xlsx`
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error downloading:", error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const downloadTeacherWiseResult = async () => {
    enqueueSnackbar("Please wait. Preparing download...", {
      variant: "info",
    });

    const response = await viewTeacherWiseResultAnalysis(teacher_id, exam_type);

    if (response.status === 200) {
      const result = response.data.data;

      if (!Array.isArray(result) || result.length === 0) {
        alert("No data to download");
        return;
      }

      // Create a single workbook
      const workbook = XLSX.utils.book_new();

      // Prepare FLAT worksheet data (single sheet)
      const worksheetData = [
        [
          "Teacher Name",
          "Class Name",
          "Subject Name",
          "Average Marks",
          "Highest Marks",
          "Lowest Marks",
          "Total Students",
          "Student Name",
          "Marks Obtained",
          "Max Marks",
        ],
      ];

      // Flatten all subjects + students into one sheet
      result.forEach((subjectData) => {
        subjectData.students.forEach((student) => {
          worksheetData.push([
            subjectData.teacher_name,
            subjectData.program_name,
            subjectData.subject_name,
            subjectData.average_marks,
            subjectData.highest_marks,
            subjectData.lowest_marks,
            subjectData.total_students,
            student.student_name,
            student.marks_obtained,
            student.max_marks,
          ]);
        });
      });

      // Convert to worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Append SINGLE sheet
      XLSX.utils.book_append_sheet(workbook, worksheet, "Teacher Wise Result");

      // Download file
      XLSX.writeFile(workbook, "ResultTeacherWise.xlsx");
    }
  };

  // const downloadTeacherWiseResult = async () => {
  //   enqueueSnackbar("Please wait. Preparing download...", {
  //     variant: "info",
  //   });
  //   const response = await viewTeacherWiseResultAnalysis(teacher_id, exam_type);

  //   if (response.status === 200) {
  //     const result = response.data.data;

  //     if (!Array.isArray(result) || result.length === 0) {
  //       alert("No data to download");
  //       return;
  //     }
  //     const workbook = XLSX.utils.book_new();
  //     result.forEach((subjectData, index) => {
  //       const worksheetData = [
  //         [
  //           "Teacher Name",
  //           "Class Name",
  //           "Subject Name",
  //           "Average Marks",
  //           "Highest Marks",
  //           "Lowest Marks",
  //           "Total Students",
  //           "Student Name",
  //           "Marks Obtained",
  //           "Max Marks",
  //         ],
  //         ...subjectData.students.map((student) => [
  //           subjectData.teacher_name,
  //           subjectData.program_name,
  //           subjectData.subject_name,
  //           subjectData.average_marks,
  //           subjectData.highest_marks,
  //           subjectData.lowest_marks,
  //           subjectData.total_students,
  //           student.student_name,
  //           student.marks_obtained,
  //           student.max_marks,
  //         ]),
  //       ];
  //       const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //       XLSX.utils.book_append_sheet(
  //         workbook,
  //         worksheet,
  //         `${index + 1}-${subjectData.subject_name}`
  //       );
  //     });

  //     XLSX.writeFile(workbook, "ResultTeacherWise.xlsx");
  //   }
  // };
  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div className="main-title-page page-title d-flex align-items-center">
            <div className="mx-2">
              <FaUserTie />
            </div>
            <span>Result Analysis (Teacher Wise)</span>
          </div>
        </div>
      </div>
      <div className="row card-body">
        <div className="col-md-5">
          <Select
            name="teacher_id"
            placeholder="Select Teacher"
            onChangeHandler={changeHandler}
            options={teacherData}
            value={teacher_id}
          />
        </div>
        <div className="col-md-4">
          <Select
            name="exam_type"
            placeholder="Select Exam Type"
            onChangeHandler={changeHandler}
            options={[
              { id: "term-1", name: "Term-1" },
              { id: "term-2", name: "Term-2" },
            ]}
            value={exam_type}
          />
        </div>
        <div className="col-md-3">
          <Button className="btn btn-primary" onClick={fetchResultTeacherWise}>
            View
          </Button>
          <Button
            className="btn btn-success mx-2"
            onClick={downloadTeacherWiseResult}
          >
            Download Excel
          </Button>
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <div className="card-body">
          {data.length === 0 ? (
            <div className="d-flex justify-content-center">
              <h5>No data found</h5>
            </div>
          ) : (
            <div>
              {data.map((subjectData, index) => (
                <div key={index} className="mb-4 p-3 border rounded shadow-sm">
                  <div
                    className="mb-2 mt-2 px-3 py-2 rounded shadow-sm text-white fw-semibold"
                    style={{
                      background: "linear-gradient(90deg, #014f86, #0077b6)",
                      fontSize: "15px",
                    }}
                  >
                    Teacher: {subjectData.teacher_name || "N/A"}
                  </div>

                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer"
                    onClick={() => toggleSubjectExpand(index)}
                  >
                    <div className="w-100">
                      <div className="row">
                        <div className="col-md-3">
                          <strong>Class: </strong>
                          {subjectData.program_name}
                        </div>
                        <div className="col-md-3">
                          <strong>Subject: </strong>
                          {subjectData.subject_name}
                        </div>
                        <div className="col-md-3">
                          <strong>Students: </strong>
                          {subjectData.total_students}
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-3">
                          <strong>Average: </strong>
                          {subjectData.average_marks}
                        </div>
                        <div className="col-md-3">
                          <strong>Highest: </strong>
                          {subjectData.highest_marks}
                        </div>
                        <div className="col-md-3">
                          <strong>Lowest: </strong>
                          {subjectData.lowest_marks}
                        </div>
                      </div>
                    </div>
                    <div className="ms-3">
                      {expandedSubjects[index] ? (
                        <FaChevronUp className="text-muted" />
                      ) : (
                        <FaChevronDown className="text-muted" />
                      )}
                    </div>
                  </div>

                  {expandedSubjects[index] && (
                    <div className="mt-3 animate__animated animate__fadeIn">
                      <table className="table table-bordered table-hover table-sm">
                        <thead className="table-light">
                          <tr>
                            <th>Student Name</th>
                            <th className="text-center">Marks Obtained</th>
                            <th className="text-center">Max Marks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {subjectData.students.map((student, idx) => (
                            <tr key={idx}>
                              <td>{student.student_name}</td>
                              <td className="text-center">
                                {student.marks_obtained}
                              </td>
                              <td className="text-center">
                                {student.max_marks}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ResultAnalysisTeacherWise;
